export default "__VITE_ASSET__CJxeYwGx__"